<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="page-contact-view">
        <vs-alert
            color="danger"
            title="User Not Found"
            :active.sync="user_not_found"
        >
            <span
                >User record with id: {{ $route.params.userId }} not found.
            </span>
            <span>
                <span>Check </span
                ><router-link
                    :to="{ name: 'page-user-list' }"
                    class="text-inherit underline"
                    >All Users</router-link
                >
            </span>
        </vs-alert>

        <div id="user-data" v-if="user_data">
            <vx-card title="Contact" class="mb-base">
                <!-- Avatar -->
                <div class="vx-row">
                    <!-- Avatar Col -->
                    <div class="vx-col" id="avatar-col">
                        <div class="img-container mb-4">
                            <vs-avatar
                                v-if="user_data.avatar"
                                :src="user_data.avatar.image"
                                size="80px"
                                class="mr-4"
                            />
                        </div>
                    </div>

                    <!-- Information - Col 1 -->
                    <div class="vx-col flex-1" id="account-info-col-1">
                        <table>
                            <tr>
                                <td class="font-semibold">First Name</td>
                                <td>{{ user_data.first_name }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Work Email</td>
                                <td>{{ user_data.email_work }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Work Phone</td>
                                <td>{{ user_data.phone_work }}</td>
                            </tr>
                        </table>
                    </div>
                    <!-- /Information - Col 1 -->

                    <!-- Information - Col 2 -->
                    <div class="vx-col flex-1" id="account-info-col-2">
                        <table>
                            <tr>
                                <td class="font-semibold">Last Name</td>
                                <td>{{ user_data.last_name }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Personal Email</td>
                                <td>{{ user_data.email_personal }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Hand Phone</td>
                                <td>{{ user_data.phone_mobile }}</td>
                            </tr>
                        </table>
                    </div>
                    <!-- /Information - Col 2 -->
                    <div class="vx-col w-full flex" id="account-manage-buttons">
                        <vs-button
                            icon-pack="feather"
                            icon="icon-edit"
                            class="mr-4"
                            :to="{
                                name: 'app-contact-edit',
                                params: { userId: $route.params.userId },
                            }"
                            >Edit</vs-button
                        >
                        <vs-button
                            type="border"
                            color="danger"
                            icon-pack="feather"
                            icon="icon-trash"
                            @click="confirmDeleteRecord"
                            >Delete</vs-button
                        >
                    </div>
                </div>
            </vx-card>

            <div class="vx-row">
                <div class="vx-col lg:w-1/2 w-full">
                    <vx-card title="Company" class="mb-base">
                        <table>
                            <tr>
                                <td class="font-semibold">Website</td>
                                <td>{{ user_data.website }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Company Name</td>
                                <td>{{ user_data.company }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Credentials</td>
                                <td>{{ user_data.credentials }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Role</td>
                                <td>{{ user_data.role_in_company }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Department</td>
                                <td>{{ user_data.department }}</td>
                            </tr>
                        </table>
                    </vx-card>
                </div>
                <div class="vx-col lg:w-1/2 w-full">
                    <vx-card title="Address" class="mb-base">
                        <table>
                            <tr>
                                <td class="font-semibold">Road</td>
                                <td>{{ user_data.address_line_1 }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Country</td>
                                <td>{{ user_data.address_country }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Postal</td>
                                <td>{{ user_data.address_postal }}</td>
                            </tr>
                        </table>
                    </vx-card>
                </div>

                <div class="vx-col lg:w-1/2 w-full">
                    <vx-card
                        :title="
                            'QR Code (' + baseURL +
                            $route.params.userId +
                            ')'
                        "
                        class="mb-base"
                    >
                        <div ref="qr"></div>
                    </vx-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import QRCodeStyling from "qr-code-styling";
import QRCode from "qrcode";

export default {
    data() {
        return {
            user_data: null,
            user_not_found: false,
            qrValue: null,
            qrColor: "#000000",
            qrShape: "square",
            qrType: 18,
            baseURL: process.env.VUE_APP_PUBLIC_URL
        };
    },
    computed: {
        userAddress() {
            let str = "";
            for (const field in this.user_data.location) {
                str += `${field} `;
            }
            return str;
        },
    },
    methods: {
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm Delete",
                text: `You are about to delete "${this.user_data.first_name} ${this.user_data.last_name}"`,
                accept: this.deleteRecord,
                acceptText: "Delete",
            });
        },
        deleteRecord() {
            /* Below two lines are just for demo purpose */
            // this.$router.push({ name: "home" });
            // this.showDeleteSuccess();

            /* UnComment below lines for enabling true flow if deleting user */
            this.$store
                .dispatch("userManagement/removeRecord", this.user_data.id)
                .then(() => {
                    this.$router.push({ name: "home" });
                    this.showDeleteSuccess();
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: "success",
                title: "Contact Deleted",
                text: "The selected contact was successfully deleted",
            });
        },
        qrCodeImg(val) {
            this.$refs.qr.innerHTML = "";
            const qrCode = new QRCodeStyling({
                width: 150,
                height: 150,
                data: val,
                image: null,
                dotsOptions: {
                    color: this.qrColor,
                    type: this.qrShape,
                },
                backgroundOptions: {
                    color: "#fff",
                },
                imageOptions: {
                    hideBackgroundDots: true,
                    imageSize: 0.3,
                },
            });
            // eslint-disable-next-line no-console
            console.log(qrCode);
            qrCode.append(this.$refs.qr);
        },
    },
    created() {
        // Register Module UserManagement Module
        if (!moduleUserManagement.isRegistered) {
            this.$store.registerModule("userManagement", moduleUserManagement);
            moduleUserManagement.isRegistered = true;
        }

        const userId = this.$route.params.userId;
        this.$store
            .dispatch("userManagement/fetchUser", userId)
            .then((res) => {
                this.user_data = res.data;
            })
            .catch((err) => {
                if (err.response.status === 404) {
                    this.user_not_found = true;
                    return;
                }
                console.error(err);
            });
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.qrCodeImg(
                    process.env.VUE_APP_PUBLIC_URL + this.$route.params.userId
                );
            }, 2000);
        });
    },
};
</script>

<style lang="scss">
#avatar-col {
    width: 10rem;
}

#page-contact-view {
    table {
        td {
            vertical-align: top;
            min-width: 140px;
            padding-bottom: 0.8rem;
            word-break: break-all;
        }

        &:not(.permissions-table) {
            td {
                @media screen and (max-width: 370px) {
                    display: block;
                }
            }
        }
    }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
    only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
        width: calc(100% - 12rem) !important;
    }

    // #account-manage-buttons {
    //   width: 12rem !important;
    //   flex-direction: column;

    //   > button {
    //     margin-right: 0 !important;
    //     margin-bottom: 1rem;
    //   }
    // }
}
</style>
